"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = void 0;
var head = document.head || document.getElementsByTagName('head')[0];
var loadedStyleMap = {};

var load = function load(href) {
  if (loadedStyleMap[href]) return;
  if (!href) return;
  var el = document.createElement('link');
  el.type = 'text/css';
  el.rel = 'stylesheet';
  el.href = href;
  loadedStyleMap[href] = true;
  head.appendChild(el);
  return el;
};

exports.load = load;
//# sourceMappingURL=cssLoader.js.map